import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const MothersDeaths = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Indice de Obitos Maternos'}
            indicatorValue={chartData?.indicators?.mothersDeaths}
            className='aligned-container'
            goalValue={0.02}
        />
    );
};
